import state from "./module-api-state";
import mutations from "./module-api-mutations";
import actions from "./module-api-actions";
import getters from "./module-api-getters";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
